import Logger from '@/modules/logger/classes/Logger';
import { container } from 'tsyringe';

export default container.resolve(Logger);
